const translations = {
  title: 'Webhook',
  modalTitle: 'Crear nuevo Webhook',
  name: 'Nombre',
  availableUses: 'Usos disponibles',
  enabled: 'Activado',
  remainingUse: 'Uso restante',
  remainingUses: '{{count}} llamada',
  remainingUses_plural: '{{count}} llamadas',
  noLimit: 'Sin límite',
  url: 'URL',
  conditions: 'Condiciones',
  payload: 'Payload',
  details: 'Detalles',
  calls: 'Llamadas',
  status: 'Estado',
  creationDate: 'Fecha de creación',
  moreDetails: 'Más detalles',
  lessDetails: 'Menos detalles',
  statusCalled: 'Llamado',
  statusError: 'Error',
  statusSuccess: 'Éxito',
  'stays.name': 'Nombre*',
  'stays.maxRequests': 'Máximo de solicitudes posible',
  'stays.cancelReason': 'Motivo de cancelación*',
  'stays.questionnaire': 'Cuestionario*',
  'stays.editTitle': 'Editar webhook stays',
  'stays.newTitle': 'Nuevo webhook stays',
  'stays.widgetName': 'Integración con Stays',
  'stays.widgetDescription': 'Crear integración con sistemas Stays',
  'stays.widgetCategory': 'Comunicación Externa'
}

export default translations
